import React from 'react';
import {
  HomeOutlined,
  UserOutlined,
  BlockOutlined,
  UsergroupAddOutlined,
  ProjectOutlined,
  DollarOutlined,
  FileDoneOutlined,
  ToolOutlined,
  DropboxOutlined,
  TransactionOutlined,
} from '@ant-design/icons';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  render: boolean;
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'common.dashboard',
    key: 'dashboard',
    url: '/',
    icon: <HomeOutlined />,
    render: true,
  },
  {
    title: 'Firm',
    key: 'firm',
    url: '/firm',
    icon: <BlockOutlined />,
    render: false,
  },

  {
    title: 'Employee',
    key: 'employee',
    url: '/employee',
    icon: <UsergroupAddOutlined />,
    render: false,
  },
  {
    title: 'Timesheet',
    key: 'timesheet',
    url: '/timesheet',
    icon: <ProjectOutlined />,
    render: false,
  },
  {
    title: 'Payroll',
    key: 'payroll',
    icon: <DollarOutlined />,
    render: false,

    children: [
      {
        title: 'Salary',
        key: 'employeesalary',
        url: '/employeesalary',
        render: false,
      },
    ],
  },
  {
    title: 'Reports',
    key: 'reports',
    icon: <FileDoneOutlined />,
    render: false,

    children: [
      {
        title: 'Salary Report',
        key: 'employeesalaryreport',
        url: '/employeesalaryreport',
        render: false,
      },
      {
        title: 'Safety Report',
        key: 'employeesafetyreport',
        url: '/employeesafetyreport',
        render: false,
      },
      {
        title: 'Advance Report',
        key: 'employeeadvancereport',
        url: '/employeeadvancereport',
        render: false,
      },
      {
        title: 'Timesheet Report',
        key: 'employeeattendencereport',
        url: '/employeeattendencereport',
        render: false,
      },
    ],
  },

  {
    title: 'Employee Advance',
    key: 'employeeadvance',
    url: '/employeeadvance',
    icon: <TransactionOutlined />,
    render: false,
  },
  {
    title: 'Employee Safety',
    key: 'employeesafety',
    url: '/employeesafety',
    icon: <ToolOutlined />,
    render: false,
  },
  {
    title: 'Fileroom',
    key: 'fileroom',
    url: '/fileroom',
    icon: <DropboxOutlined />,
    render: false,
  },
  {
    title: 'Auth',
    key: 'auth',
    icon: <UserOutlined />,
    render: false,

    children: [
      {
        title: 'User',
        key: 'user',
        url: '/user',
        render: false,
      },
    ],
  },
];
